import { Link } from 'react-router-dom';
import { Battery, Gauge, Zap, ArrowRight } from 'lucide-react';

export default function CarCard({ car, index = 0 }) {
  return (
    <div
      className="car-card group animate-fadeInUp"
      style={{ animationDelay: `${index * 0.1}s` }}
      data-testid={`car-card-${car.slug}`}
      role="article"
      aria-labelledby={`car-title-${car.slug}`}
    >
      {/* Image Container */}
      <div className="relative overflow-hidden aspect-car">
        <img 
          src={car.image_url}
          alt={`${car.name} - ${car.tagline}`}
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
        />
        
        {/* Badges */}
        <div className="absolute top-4 left-4 flex gap-2">
          {car.is_bestseller && (
            <span className="badge-bestseller" data-testid={`badge-bestseller-${car.slug}`}>
              Terlaris
            </span>
          )}
          {car.is_featured && !car.is_bestseller && (
            <span className="badge-featured">
              Featured
            </span>
          )}
        </div>

        {/* Category Badge */}
        <div className="absolute top-4 right-4">
          <span className="bg-white/90 backdrop-blur-sm px-3 py-1 text-xs font-medium text-slate-700">
            {car.category}
          </span>
        </div>

        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
          <Link 
            to={`/mobil/${car.slug}`}
            className="bg-white px-6 py-3 flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300"
            data-testid={`car-card-link-${car.slug}`}
          >
            <span className="text-sm font-medium">Lihat Detail</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="mb-2">
          <span className="text-label">{car.category}</span>
        </div>
        <h3 id={`car-title-${car.slug}`} className="text-xl font-bold text-slate-900 mb-2">{car.name}</h3>
        <p className="text-sm text-slate-600 mb-4 line-clamp-2">{car.tagline}</p>

        {/* Specs */}
        <div className="flex flex-wrap gap-4 mb-4" role="list" aria-label="Spesifikasi">
          <div className="flex items-center gap-1.5" role="listitem">
            <Battery className="w-4 h-4 text-green-600" aria-hidden="true" />
            <span className="text-xs text-slate-600">{car.battery_range}</span>
          </div>
          <div className="flex items-center gap-1.5" role="listitem">
            <Gauge className="w-4 h-4 text-blue-600" aria-hidden="true" />
            <span className="text-xs text-slate-600">{car.motor_power}</span>
          </div>
          <div className="flex items-center gap-1.5" role="listitem">
            <Zap className="w-4 h-4 text-yellow-600" aria-hidden="true" />
            <span className="text-xs text-slate-600">{car.charging_time}</span>
          </div>
        </div>

        {/* Price */}
        <div className="pt-4 border-t border-slate-100">
          <div className="flex items-center justify-between">
            <div>
              <span className="text-xs text-slate-500">Mulai dari</span>
              <p className="text-lg font-bold text-slate-900">{car.price_range || car.price}</p>
            </div>
            <Link 
              to={`/mobil/${car.slug}`}
              className="btn-secondary py-2 px-4 text-sm min-h-[44px] flex items-center"
              aria-label={`Lihat detail ${car.name}`}
            >
              Detail
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
